module.exports = __webpack_public_path__ + "static/media/icon-supplies-bakingsoda.4f09e06b.svg";